(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name applicationParameters.controller:ApplicationParametersCtrl
	 *
	 * @description
	 *
	 */
	angular.module('applicationParameters').controller(
			'ApplicationParametersCtrl', ApplicationParametersCtrl);

	function ApplicationParametersCtrl(ApplicationParametersService,
			CommonMasterData, MessageService) {
		var vm = this;
		vm.ctrlName = 'ApplicationParametersCtrl';

		vm.model = {
			searchCriteria : {},
			appParamList : {// grid data
				generalAppParams : [],
				regulationAppParams : [],
				biddingAppParams : [],
				downLoadManagerAppParams : [],
				patternAppParams : [],
				updateNow : false
			},
			showFooter : false
		};

		vm.searchAppParams = function() {
			loadAppParamList();
		}

		// get load App Parameter List
		function loadAppParamList() {
			var searchRequest = ApplicationParametersService
					.getAppParamSearchRequest(vm.model.searchCriteria);
			CommonMasterData
					.loadAppParamList(
							searchRequest,
							function(response) {
								if (!!response.appParamGroupMap
										&& response.appParamGroupMap != null) {
									setGivenAppParamListByMap(response.appParamGroupMap);
								}
							},
							function() {
								console
										.log('Application Parameter list retrieval error');
							});
		}

		// set each list to the corresponding list
		function setGivenAppParamListByMap(appParamMapList) {
			vm.model.appParamList.generalAppParams = ApplicationParametersService
					.adaptAppParamMapList(appParamMapList['GENERAL']);
			vm.model.appParamList.regulationAppParams = ApplicationParametersService
					.adaptAppParamMapList(appParamMapList['REGULATION']);
			vm.model.appParamList.biddingAppParams = ApplicationParametersService
					.adaptAppParamMapList(appParamMapList['BIDDING']);
			vm.model.appParamList.downLoadManagerAppParams = ApplicationParametersService
					.adaptAppParamMapList(appParamMapList['DOWNLOAD_MANAGER']);
			vm.model.appParamList.patternAppParams = ApplicationParametersService
					.adaptAppParamMapList(appParamMapList['PATTERN']);
		}

		vm.clickOnValue = function(group, $index) {
			if (group == 'GENERAL') {
				vm.model.appParamList.generalAppParams[$index].show = vm.model.appParamList.generalAppParams[$index].editable ? !vm.model.appParamList.generalAppParams[$index].show
						: vm.model.appParamList.generalAppParams[$index].show;
			} else if (group == 'REGULATION') {
				vm.model.appParamList.regulationAppParams[$index].show = vm.model.appParamList.regulationAppParams[$index].editable ? !vm.model.appParamList.regulationAppParams[$index].show
						: vm.model.appParamList.regulationAppParams[$index].show;
			} else if (group == 'BIDDING') {
				vm.model.appParamList.biddingAppParams[$index].show = vm.model.appParamList.biddingAppParams[$index].editable ? !vm.model.appParamList.biddingAppParams[$index].show
						: vm.model.appParamList.biddingAppParams[$index].show;
			} else if (group == 'DOWNLOAD_MANAGER') {
				vm.model.appParamList.downLoadManagerAppParams[$index].show = vm.model.appParamList.downLoadManagerAppParams[$index].editable ? !vm.model.appParamList.downLoadManagerAppParams[$index].show
						: vm.model.appParamList.downLoadManagerAppParams[$index].show;
			} else if (group == 'PATTERN') {
				vm.model.appParamList.patternAppParams[$index].show = vm.model.appParamList.patternAppParams[$index].editable ? !vm.model.appParamList.patternAppParams[$index].show
						: vm.model.appParamList.patternAppParams[$index].show;
			}
		};

		vm.validateValue = function(group, $index) {
			vm.model.showFooter = true;
			if (group == 'GENERAL') {
				isAppParamValid(vm.model.appParamList.generalAppParams[$index]);
			} else if (group == 'REGULATION') {
				isAppParamValid(vm.model.appParamList.regulationAppParams[$index]);
			} else if (group == 'BIDDING') {
				isAppParamValid(vm.model.appParamList.biddingAppParams[$index]);
			} else if (group == 'DOWNLOAD_MANAGER') {
				isAppParamValid(vm.model.appParamList.downLoadManagerAppParams[$index]);
			} else if (group == 'PATTERN') {
				isAppParamValid(vm.model.appParamList.patternAppParams[$index]);
			}
		};

		function isAppParamValid(appParam) {
			appParam.isInvalid = false;
			// C - Curreny, N -Numeric, D - Dropdown, S - String normal text
			if (appParam.type == 'S') {
				// validate for string
				if (appParam.paramValue === undefined
						|| appParam.paramValue == null
						|| appParam.paramValue.trim().length <= 0) {
					appParam.isInvalid = true;
				}
			} else if (appParam.type == 'C') {
				// validate for currency
			} else if (appParam.type == 'D') {
				// validate drop down
			} else if (appParam.type == 'N') {
				if ((appParam.paramValue === 0 ||appParam.paramValue >0)?false:true) {
					appParam.isInvalid = true;
				}
			}
		}

		vm.onUpdateClick = function() {

			// all values are valid
			if (!checkInvalidValuesExist()) {
				ApplicationParametersService
						.saveAppParameters(
								vm.model.appParamList,
								function(response) {
									if (response.success) {
										MessageService
												.success('Application Parameters saved Successfully!');
										loadAppParamList();
									} else if (!!response.errors
											&& response.errors.length > 0) {
										MessageService
												.error(response.errors[0]);
									}
								}, function(error) {
						//			MessageService.error(error);
								});
			}
		}

		function checkInvalidValuesExist() {
			if (isInvalidValueExistInAppParamList(vm.model.appParamList.generalAppParams)
					|| isInvalidValueExistInAppParamList(vm.model.appParamList.regulationAppParams)
					|| isInvalidValueExistInAppParamList(vm.model.appParamList.biddingAppParams)
					|| isInvalidValueExistInAppParamList(vm.model.appParamList.downLoadManagerAppParams)
					|| isInvalidValueExistInAppParamList(vm.model.appParamList.patternAppParams)) {
				return true;
			}
			return false;

		}

		function isInvalidValueExistInAppParamList(list) {
			for (var i = 0; i < list.length; i++) {
				if (list[i].isInvalid) {
					return true;
				}
			}
			return false;
		}

		loadAppParamList();
	}
}());
